.items {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
